import NewlyListed from './NewlyListed';
export default NewlyListed;